// extracted by mini-css-extract-plugin
export default {"btnBlack":"all_btnBlack__t470Q","btnWhite":"all_btnWhite__M4NET"};